var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhiteArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 12,
    viewBox: "0 0 7 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M4.73738 6.00387L0.867376 9.87087C0.799407 9.93851 0.745471 10.0189 0.708669 10.1075C0.671866 10.196 0.65292 10.291 0.65292 10.3869C0.65292 10.4828 0.671866 10.5777 0.708669 10.6663C0.745471 10.7548 0.799407 10.8352 0.867376 10.9029C1.00528 11.0389 1.19119 11.1151 1.38488 11.1151C1.57856 11.1151 1.76447 11.0389 1.90238 10.9029L6.28738 6.52187C6.41984 6.38879 6.49593 6.2098 6.49984 6.02208C6.50375 5.83435 6.43518 5.65234 6.30838 5.51387L1.90638 1.10187C1.76952 0.964486 1.5837 0.887095 1.38979 0.88672C1.19588 0.886345 1.00976 0.963017 0.872376 1.09987C0.734994 1.23672 0.657603 1.42254 0.657228 1.61645C0.656852 1.81037 0.733524 1.99649 0.870376 2.13387L4.73738 6.00387Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteArrowDown);
export default __webpack_public_path__ + "static/media/white-arrow-down.ef61734e0acb339ccf8acb5ced57106e.svg";
export { ForwardRef as ReactComponent };